export default "__VITE_ASSET__B$CIyWQz__"